import { render, staticRenderFns } from "./FoodSupplements.vue?vue&type=template&id=57637f15&scoped=true&"
import script from "./FoodSupplements.vue?vue&type=script&lang=js&"
export * from "./FoodSupplements.vue?vue&type=script&lang=js&"
import style0 from "./FoodSupplements.vue?vue&type=style&index=0&id=57637f15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57637f15",
  null
  
)

export default component.exports